/* eslint-disable camelcase */

import React from 'react';
import queryString from 'query-string';
import { Trans } from 'react-i18next';
import classes from './classes.module.scss';
import {
  numberOfReviewsFilters, filtersAllowedParams, readingViaFilters
} from '../../../../config/const';
import  { paramOrNul } from '../../../../../common/config/utils';
import { SvgIcon } from '../../../../../common/sprites';
import Autocomplete from '../../../header/autocomplete';

export const getFilterPricePerMinute = () => window.store?.getState()?.application?.dynamicConfig?.localFilterPricePerMinute || {};

const resolveFilterPricePerMinute = (fromProps) => {
  if (fromProps != null && fromProps.min != null && fromProps.max != null) {
    return fromProps;
  }
  return getFilterPricePerMinute();
};

export const buildQueryString = ({
  readingVia, numberOfReviews, ppmRange, includeOffline, query, historySearch
}) => {
  const { currency } = window.store?.getState()?.user || window.store?.getState()?.application?.dynamicConfig?.currency || 'USD';
  const parsedHistorySearch = queryString.parse(historySearch);
  let searchWithoutFilters = { };
  Object.keys(parsedHistorySearch).filter((el) => !filtersAllowedParams.includes(el))
    .forEach((el) => {
      searchWithoutFilters = { ...searchWithoutFilters, [el]: parsedHistorySearch[el] };
    });
  const { min, max } = getFilterPricePerMinute();
  const hasPpmFilter = ppmRange[0] !== min || ppmRange[1] !== max;
  return queryString.stringify({
    ...(readingViaFilters[readingVia] === readingViaFilters.default ? null : { reading_via:readingVia }),
    ...(numberOfReviewsFilters[numberOfReviews] === numberOfReviewsFilters['0'] ? null : { min_number_of_reviews_ge:numberOfReviews }),
    ...(ppmRange[0] === min ? null : { ppm_ge: ppmRange[0] }),
    ...(ppmRange[1] === max ? null : { ppm_le: ppmRange[1] }),
    ...(hasPpmFilter && currency !== 'USD' ? { local_currency: currency } : null),
    ...(includeOffline ? null : { include_offline: includeOffline }),
    ...paramOrNul('query', query),
    ...searchWithoutFilters
  });
};

export const getInitialState = (state, localFilterPricePerMinute) => {
  const {
    include_offline, min_number_of_reviews_ge, ppm_ge, ppm_le, reading_via, query
  } = queryString.parse(window.location.search);
  const { min, max } = resolveFilterPricePerMinute(localFilterPricePerMinute);
  const states = {
    readingVia: reading_via || 'default',
    numberOfReviews: min_number_of_reviews_ge || '0',
    ppmRange: [ppm_ge || min, ppm_le || max],
    includeOffline: include_offline !== 'false',
    searchQuery: query
  };
  return states[state];
};

const renderAffiliatFilterViewBullet = (iconId, localizationKey) => (
  <div className={ classes.newToPGSectionMarksContainer }>
    <div className={ classes.newToPGSectionMarkContainer }>
      <SvgIcon className={ classes.newToPGSectionMarkImg } size={ 50 } id={ iconId } />
      <div className={ classes.bullet } />
      <div className={ classes.newToPGSectionMarkTextContainer }>
        <Trans
          i18nKey={ localizationKey }
          components={ {
            bold:<b className={ classes.boldText } />,
            normal:<span className={ classes.normalText } />
          } }
        />
      </div>
    </div>
  </div>
);

export const renderViewForNewAffiliateUser = ({
  showFilterPopover, title, t
}) => (
  <div className={ classes.viewForNewAffiliateUser } data-testid="for-new-affilate-user">
    <Trans
      i18nKey={ title }
      components={ {
        bold:<b className={ classes.boldText } />,
        normal:<span className={ classes.normalText } />
      } }
    />
    <div className={ classes.newToPGSectionMarksContainer }>
      {renderAffiliatFilterViewBullet('filter_to_new_browse', t('search_results.browse_and_find'))}
      {renderAffiliatFilterViewBullet('filter_to_new_account', t('search_results.create_an_account'))}
      {renderAffiliatFilterViewBullet('filter_to_new_connect', t('search_results.select_chat_duration_and'))}
    </div>
    <div key="short_view" className={ classes.filterButtonContainer }>
      <button type="button" className={ classes.displayFilterButton } onClick={ showFilterPopover }>
        {t('search_results.need_help')}
          &nbsp;
        <span className={ classes.clickHereBtn }>{t('search_results.click_here')}</span>
      </button>
    </div>
  </div>
);

export const renderFiltersMobileView = ({
  popoverView, showFilterPopover, t,
  eligibleForNewAffiliateUserView, searchQuery, onSearchChanged, onFilterApplyKeyDown, shouldCloseAutocomplete
}) => {
  if (popoverView) return null;
  const title = t('app_search_results.new_to_purple_garden');
  return eligibleForNewAffiliateUserView ? (
    <div className={ classes.mobileViewForNewAffiliateUser }>
      {renderViewForNewAffiliateUser({ showFilterPopover, title, t })}
    </div>
  ) : (
    <div key="short_view" className={ classes.filterButtonContainer } data-testid="filter-button-container">
      <div className={ classes.mobileSearchInputContainer }>
        <SvgIcon id="gray_search_icon" className={ classes.mobileSearchIcon } />
        <input
          value={ searchQuery || '' }
          onChange={ onSearchChanged }
          onKeyDown={ onFilterApplyKeyDown }
          type="text"
          className={ classes.input }
          placeholder={ t('search_placeholder') }
          data-testid="mobile-search-input"
          autoComplete="off"
        />
        <Autocomplete t={ t } query={ searchQuery } clickSource="mobile search autocomplete" className={ classes.autocompleteMobileFilter } shouldClose={ shouldCloseAutocomplete } />
      </div>
      <button key="filter_button" type="button" className={ classes.filterIconButton } onClick={ showFilterPopover }>
        <SvgIcon id="filter_icon" className={ classes.filterIconButtonImg } />
      </button>
    </div>
  );
};

export const renderCancelBtn = (showFilters, eligibleForNewAffiliateUserView, popoverView, closeFilters) => (
  showFilters && eligibleForNewAffiliateUserView && !popoverView  ? (
    <button type="button" className={ classes.closeButton } onClick={ closeFilters } data-testid="close-filters-button">
      <SvgIcon id="circle_close_icon" />
    </button>
  ) : null
);

export const getFilterSwitcherId = ({ popoverView }) => {
  if (popoverView) return 'filterSwitcherPopover';
  return 'filterSwitcher';
};
